import {publishEvent} from '../analytics/pub-sub';
import {ANALYTIC_EVENTS} from '../analytics/pub-sub/constants';

const handleOneSignalEmbedAnalyticEvents = oneSignalContainerElement => {
  if (!oneSignalContainerElement) {
    return;
  }

  const oneSignalButtonElement = oneSignalContainerElement.querySelector('.onesignal-customlink-container');

  if (oneSignalButtonElement) {
    oneSignalButtonElement.addEventListener('click', () => {
      publishEvent(ANALYTIC_EVENTS.ONE_SIGNAL_EMBED_EMBED_CLICK);
    });
  }

  const observer = new IntersectionObserver(changes => {
    changes.forEach(change => {
      if (change.isIntersecting) {
        publishEvent(ANALYTIC_EVENTS.ONE_SIGNAL_EMBED_EMBED_IMPRESSION);
      }
    });
  }, {threshold: 0.5});

  observer.observe(oneSignalContainerElement);
};

export {handleOneSignalEmbedAnalyticEvents};
